import { Component, computed, input } from '@angular/core';
import { Notification, NotificationMessageLevels } from '../../shared/models/users-profile.models';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-notifications',
  imports: [MatButtonModule, FontAwesomeModule, DatePipe],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
})
export class NotificationsComponent {
  notifications = input.required<{ read: Notification[]; unread: Notification[] }>();

  currentList: 'all' | 'unread' = 'all';

  displayedNotifications = computed(() =>
    this.currentList === 'all'
      ? [...this.notifications().unread, ...this.notifications().read]
      : this.notifications().unread,
  );

  iconsMap: Record<NotificationMessageLevels, { name: string; color: string }> = {
    [NotificationMessageLevels.LEVEL_SUCCESS]: {
      name: 'circle-check',
      color: '#22C55E',
    },
    [NotificationMessageLevels.LEVEL_ERROR]: {
      name: 'circle-xmark',
      color: '#EF4444',
    },
    [NotificationMessageLevels.LEVEL_INFO]: {
      name: 'circle-info',
      color: '#3B82F6',
    },
    [NotificationMessageLevels.LEVEL_WARNING]: {
      name: 'circle-exclamation',
      color: '#F59E0B',
    },
  };

  switchDisplayedNotifications(list: 'all' | 'unread'): void {
    this.currentList = list;
  }
}
